export const MAX_INSTAGRAM_BUTTONS_COUNT = 3;
export const INSTAGRAM_BUTTON_NAME_MAX_LENGTH = 20;
